import { Tracker } from '@cpd-app/core-module/models';

export const trackerFeatureKey = 'tracker';

export interface TrackerState extends Tracker {
  hasLoaded: boolean;
}

export const initialTrackerState: TrackerState = {
  videoUsage: null,
  hasLoaded: false,
  interestSurveyTracker: null
};
